import BaseApi from '../../../infraestructure/BaseApi';

export default class ApiKnowledgeAreas extends BaseApi {
    constructor(client, endPoint) {
        super(client, endPoint)
    }
}